module.exports = __webpack_public_path__ + "static/media/25.423c43c4.png";